import React, { useEffect, useState, useRef } from 'react'
import {
    Button,
    Avatar,
    Card,
    Modal,
    message,
    Divider,
    Input,
    Empty,
} from 'antd';
import './index.scss'
import { chat, sys } from "../../service";
import { useSelector } from 'react-redux';

export default function ChatHistoryView(props) {

    const { open, chatId, toId } = props
        , scrollableDivRef = useRef(null)
        , [chatList, setChatList] = useState([])
        , [loading, setLoading] = useState(false)
        , [textAreaValue, setTextAreaValue] = useState('')
        , [sendUser, setSendUser] = useState({})
        , [receiveUser, setReceiveUser] = useState({})
        , basic = useSelector(state => state.basic)
        , { serverUrl } = useSelector(state => state.siteInfo)

    useEffect(() => {
        if (toId && open) {
            async function fetchData() {
                getChatList()
                getUserInfo()
            }
            fetchData()
        }
    }, [open])

    // 获取用户信息等
    const getUserInfo = async () => {
        const data1 = await sys.getUserBasic(toId)
        const data2 = await sys.getUserBasic(basic.id)
        setSendUser(data2.data)
        setReceiveUser(data1.data)
    }

    // 获取聊天记录
    const getChatList = async () => {
        setLoading(true)
        try {
            const { data } = await chat.apiChat.history(toId)
            setChatList(data)
            setLoading(false)
            // 检查是否有可滚动的 div 元素
            if (scrollableDivRef.current) {
                // 滚动到底部
                setTimeout(() => {
                    scrollableDivRef.current.scrollTop = scrollableDivRef.current.scrollHeight;
                }, 500);
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
        }

    }

    // 回车发送消息
    const handleEnterKeyPress = (e) => {
        if (e.key === 'Enter') {
            sendChat()
        }
    }

    const handleTextAreaChange = (e) => {
        const value = e.target.value;
        setTextAreaValue(value);
    }

    // 发送消息
    const sendChat = async () => {
        try {
            const params = {
                content: textAreaValue,
                fromId: basic.id,
                toId: toId,
                chatId: chatId,
            }
            await chat.apiChat.send(params)
            setTextAreaValue(null);
            getChatList()
        } catch (error) {
            console.log(error);
            message.error('发送失败！')
        }
    }

    const onClose = () => {
        props.onClose()
    }

    return (
        <Modal
            title='消息记录'
            width={800}
            open={open}
            onCancel={onClose}
            footer={null}
            className='send-chat-modal'
        >
            <div
                ref={scrollableDivRef}
                className='chat-history p-sm scrollbar'
            >
                {
                    chatList.length ? (chatList.map(item => (
                        item.fromId === basic.id ? (
                            <div className='flex chat end reverse'>
                                <div className='m-r-sm'>
                                    <div className='name'>{`${item.createDate}  ${sendUser.name}`}</div>
                                    <div className='content triangle-reverse'>{item.content}</div>
                                </div>
                                <Avatar size={50} src={<img src={serverUrl + sendUser.imageUrl} />} />
                            </div>
                        ) : (
                            <div className='flex chat'>
                                <Avatar size={50} src={<img src={serverUrl + receiveUser.imageUrl} />} />
                                <div>
                                    <div className='m-l-sm'>
                                        <div className='name'>{`${receiveUser.name}  ${item.createDate}`}</div>
                                        <div className='content triangle'>{item.content}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    ))) : (<Empty description='暂无消息记录' />)
                }
            </div>

            <Divider className='m-t-sm m-b-sm' />

            <div className='send-box'>
                <Input.TextArea
                    rows={4}
                    placeholder="请输入"
                    bordered={false}
                    value={textAreaValue}
                    onKeyDown={handleEnterKeyPress}
                    onChange={handleTextAreaChange}
                />
                <Button
                    type='primary'
                    className='send-btn'
                    onClick={sendChat}
                >发送</Button>
            </div>
        </Modal>
    )
}
